import React, { useContext } from 'react';

import { list } from '../../apis/products';
import { ShopContext } from '../../store/contexts';
import { useApiQuery } from '../../hooks/useApiQuery';
import { usePagination } from '../../hooks/usePagination';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

import { CategoriesCarousel } from '../../components/categories/CategoriesCarousel';
import { ProductsGrid } from '../../components/products/ProductsGrid';

export const HomePage = () => {
    useDocumentTitle('Home');

    const { categories } = useContext(ShopContext);
    const { pagination, handlers } = usePagination({
        page: 1,
        size: 12
    });
    const products = useApiQuery(list, pagination);

    return (
        <div>
            <CategoriesCarousel className="mt-3" {...categories} />
            <ProductsGrid className="mt-5 mb-5" {...handlers} {...products} />
        </div>
    );
};
